import { loadStripe } from '@stripe/stripe-js';

const API_BASE = '/api';

// Inicializar Stripe (a chave pública será carregada do backend via ConfigurationService)
let stripePromise = null;

export const getStripe = async () => {
    if (!stripePromise) {
        const response = await fetch(`${API_BASE}/configuration/stripe/publishable-key`);
        const { publishableKey } = await response.json();
        if (publishableKey) {
            stripePromise = loadStripe(publishableKey);
        }
    }
    return stripePromise;
};

export const paymentService = {
    // Criar sessão de checkout Stripe para compra de créditos
    async createCheckoutSession(creditPackage, userId) {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE}/payments/create-checkout-session`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                packageId: creditPackage.id,
                amount: creditPackage.price,
                credits: creditPackage.credits,
                userId: userId,
                successUrl: `${window.location.origin}/credits?success=true`,
                cancelUrl: `${window.location.origin}/credits?canceled=true`
            })
        });
        
        if (!response.ok) {
            throw new Error('Erro ao criar sessão de pagamento');
        }
        
        return response.json();
    },

    // Redirecionar para Stripe Checkout
    async redirectToCheckout(sessionId) {
        const stripe = await getStripe();
        const { error } = await stripe.redirectToCheckout({ sessionId });
        
        if (error) {
            throw new Error(error.message);
        }
    },

    // Iniciar pagamento MB Way
    async initiateMBWayPayment(phoneNumber, amount, userId) {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE}/payments/mbway`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                phoneNumber,
                amount,
                userId
            })
        });
        
        if (!response.ok) {
            throw new Error('Erro ao iniciar pagamento MB Way');
        }
        
        return response.json();
    },

    // Verificar estado do pagamento MB Way
    async checkMBWayStatus(paymentId) {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE}/payments/mbway/status/${paymentId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        
        return response.json();
    },

    // Obter histórico de transações
    async getTransactionHistory() {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE}/payments/transactions`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        
        return response.json();
    },

    // Obter saldo atual de créditos
    async getCreditBalance() {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE}/credits/balance`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        
        return response.json();
    }
};

export default paymentService;
